export default {
    cloudapi:'https://cloud.9678auto.com',
    // cloudapi:'https://cloud.gmgauto.one',
    // cloudapi:'https://iprocloud.gmgauto.one',
    // cloudapi:'https://app1cloud.gmgauto.one',
    // cloudapi:'https://app2cloud.gmgauto.one',
    // cloudapi:'https://gmgxapi.g-one.dev',
    // cloudapi:'https://cloud.usdlink.co', 
    // cloudapi:'https://sturdy-meme-v646wv44gqpqcpr6p-4001.app.github.dev', 
    gmz:'AMB'
}; 
